.welcome {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-4);
  padding: var(--tuna-spacing-4);
}
.intro {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}
.title {
  margin: 0;
}
.tagline {
  margin: 0;
  color: var(--tuna-content-secondary);
}
.subModeGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--tuna-spacing-3);
}
.subModeCard {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-4);
  align-items: flex-start;
  text-align: left;
}
.cardTitle {
  font-size: var(--tuna-typography-h4-fontSize);
  font-weight: 600;
}
.cardBody {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}
.options {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  padding: var(--tuna-spacing-3);
}
